export const vlan = {
  iptv_select: "vlan_iptv_select_by_bridge",
  vlan_select: "vlan_iptv_select_by_VLANtag",
  enable_vlan_id: "iptv_vlan_id_enable",
  vlan_id_input: "iptv_vlan_id",
  vlan_type: "vlan_isp",
  add: "Add",
  edit: "Edit",
  delete: "Delete",
};

export default vlan;
